exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nav-bar-menu[data-v-8b756b50] {\n  cursor: pointer;\n}\n.big-icon[data-v-8b756b50] {\n  font-size: 2em !important;\n}\n", "", {"version":3,"sources":["/var/www/zp_frontend_vuejs/src/layout/DashboardNavbar.vue"],"names":[],"mappings":"AA0EA;EAAgB,gBAAe;CAAA;AAC/B;EAAY,0BAAyB;CAAA","file":"DashboardNavbar.vue?vue&type=style&index=0&id=8b756b50&lang=scss&scoped=true&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.nav-bar-menu { cursor: pointer; }\n.big-icon { font-size: 2em !important;}\n"],"sourceRoot":""}]);

// exports
